import React from 'react';
import { Landmark, Globe, Compass } from 'lucide-react';
import { LegalOrigin } from '../../types';

interface LegalOriginTagProps {
  origin: LegalOrigin;
  size?: 'sm' | 'md';
}

export const LegalOriginTag: React.FC<LegalOriginTagProps> = ({
  origin,
  size = 'md'
}) => {
  let bgClass = '';
  let textClass = '';
  let borderClass = '';
  let badgeLabel = '';
  let IconComponent = Landmark;

  switch (origin) {
    case 'NATIONAL':
      bgClass = 'bg-slate-50';
      textClass = 'text-slate-700';
      borderClass = 'border-slate-200';
      badgeLabel = 'National (Cameroun)';
      IconComponent = Landmark;
      break;
    case 'COMMUNITY':
      bgClass = 'bg-emerald-50';
      textClass = 'text-emerald-800';
      borderClass = 'border-emerald-200';
      badgeLabel = 'Communautaire (CEMAC / OHADA)';
      IconComponent = Globe;
      break;
    case 'INTERNATIONAL':
      bgClass = 'bg-indigo-50';
      textClass = 'text-indigo-800';
      borderClass = 'border-indigo-200';
      badgeLabel = 'International';
      IconComponent = Compass;
      break;
  }

  const paddingClass = size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs';
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5';

  return (
    <span className={`inline-flex items-center gap-1.5 font-medium border rounded-md ${bgClass} ${textClass} ${borderClass} ${paddingClass} transition-colors tracking-wide`}>
      <IconComponent className={`${iconSize} shrink-0 opacity-80`} />
      <span>{badgeLabel}</span>
    </span>
  );
};
